module.exports = __webpack_public_path__ + "static/Carly_Daniel11-0d4849213fb558d8b84ee457dcf03279.jpg";